import React, { memo, useCallback, useContext } from 'react';
import { LayoutAnimation, Platform, StyleSheet, View } from 'react-native';
import { IconChip } from 'design-system/controls';
import { IconSettings } from 'design-system/icons/IconSettings';
import { PickerModal } from 'design-system/picker/PickerModal';
import useColors from 'hooks/useColors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { WalkthroughContext } from 'features/feed/components/walkthrough/context';
import TouchHelper from 'features/feed/components/walkthrough/TouchHelper';
import { rem } from 'design-system';
import { setChartType } from '../actions';
import { selectChartType } from '../selectors';
import { CHART_TYPE_OPTIONS, CHART_TYPE_OPTIONS_WALKTHROUGH, } from '../constants';
const AnalyticsChartSwitcher = ({ onNext }) => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    const chartType = useAppSelector(selectChartType);
    const isInWalkthrough = useContext(WalkthroughContext);
    const onPressChartSettings = useCallback(() => {
        onNext?.();
        PickerModal.show({
            pickerOptions: isInWalkthrough
                ? CHART_TYPE_OPTIONS_WALKTHROUGH
                : CHART_TYPE_OPTIONS,
            selectedIconFill: colors.elements.brand,
            selectedValue: CHART_TYPE_OPTIONS.find((item) => item.value === chartType),
            onSelected: (selected) => {
                if (Platform.OS === 'ios' && !isInWalkthrough) {
                    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
                }
                dispatch(setChartType(selected.value));
                onNext?.();
            },
            overlay: isInWalkthrough ? (<View pointerEvents="none" style={styles.overlay}>
            <TouchHelper />
          </View>) : null,
        }, {
            title: 'Chart type',
            noBackdrop: isInWalkthrough,
            nonDismissable: isInWalkthrough,
        }, undefined);
    }, [chartType, colors.elements.brand, isInWalkthrough, onNext]);
    return (<IconChip onPress={onPressChartSettings} style={isInWalkthrough ? styles.walkthroughIconChip : undefined}>
      <IconSettings color={colors.elements.secondary}/>
    </IconChip>);
};
const styles = StyleSheet.create({
    overlay: {
        ...StyleSheet.absoluteFillObject,
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: rem(50),
        paddingLeft: rem(100),
    },
    walkthroughIconChip: {
        marginRight: 0,
    },
});
export default memo(AnalyticsChartSwitcher);
